import { useMutation, useQueryClient } from '@tanstack/react-query';

import { accountKeys } from '~teacher/hook/account';
import { teamsKeys } from '~teacher/hook/team/teamsKeys';

import { acceptTeamInvite } from '../../../api/teams/acceptTeamInvite';

export function useAcceptTeamInvite() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: acceptTeamInvite,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [teamsKeys.all, accountKeys.account],
      });
    },
  });
}
